import { render, staticRenderFns } from "./FormDetail.vue?vue&type=template&id=4b232955&"
import script from "./FormDetail.vue?vue&type=script&lang=js&"
export * from "./FormDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b232955')) {
      api.createRecord('4b232955', component.options)
    } else {
      api.reload('4b232955', component.options)
    }
    module.hot.accept("./FormDetail.vue?vue&type=template&id=4b232955&", function () {
      api.rerender('4b232955', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/incident/handling/FormDetail.vue"
export default component.exports